import { Checkbox, FormControlLabel } from '@mui/material';

interface SignDeclarationProps {
  /** Hidden when the director picked a signature they had already saved —
   *  saving it again would add a duplicate to their list every time they sign. */
  canSave: boolean;
  saveSignature: boolean;
  onSaveSignatureChange: (next: boolean) => void;
  hasViewedDocuments: boolean;
  onHasViewedDocumentsChange: (next: boolean) => void;
}

/**
 * The two declarations a director makes when signing, shared by the standalone
 * sign dialog and the guided flow's signing step so both ask the same thing in
 * the same words.
 *
 * Neither is a field on the signing request. Saving posts the image to the
 * signature list as a second call, and the viewed declaration marks the
 * document seen through its own endpoint — which is how the legacy portal
 * recorded both, and what the backend still expects.
 */
export const SignDeclaration = ({
  canSave,
  saveSignature,
  onSaveSignatureChange,
  hasViewedDocuments,
  onHasViewedDocumentsChange,
}: SignDeclarationProps) => (
  <div className="flex flex-col">
    {canSave && (
      <FormControlLabel
        control={
          <Checkbox
            checked={saveSignature}
            onChange={(event) => {
              onSaveSignatureChange(event.target.checked);
            }}
          />
        }
        label="Save this signature for future use"
      />
    )}

    <FormControlLabel
      control={
        <Checkbox
          checked={hasViewedDocuments}
          onChange={(event) => {
            onHasViewedDocumentsChange(event.target.checked);
          }}
        />
      }
      label="I declare that I have viewed the documents"
    />
  </div>
);
